import { mqttConfig } from "@t-soft-io/retail-shared/platform";
import { DomainConfig } from "../types";

const config: DomainConfig = {
  API_BASE_URL: "/api/v2",
  APP_KEY: "BMW",
  CLIENT_ID: "1",
  ...mqttConfig("dev"),
};

export default config;
